import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledModalContent: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  gap: ${({ theme }) => theme.size.static400};

  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.size.static300};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  font-family: vw-head, sans-serif;
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  width: ${({ theme }) => theme.size.grid022};
  padding: ${({ theme }) => theme.size.static250};

  @media (min-width: ${Breakpoints.b560}px) {
    width: ${({ theme }) => theme.size.grid016};
    padding: ${({ theme }) => theme.size.static450};
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: ${({ theme }) => theme.size.grid012};
    padding-top: ${({ theme }) => theme.size.static500};
    padding-bottom: ${({ theme }) => theme.size.static500};
    padding-left: ${({ theme }) => theme.size.static520};
    padding-right: ${({ theme }) => theme.size.static520};
  }
`;

export const StyledContentWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.size.static400};

  @media (min-width: ${Breakpoints.b560}px) {
    gap: ${({ theme }) => theme.size.static150};
  }
`;

export const StyledPinVerificationWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static300};

  & [class^='StyledLabel-'],
  & [class*=' StyledLabel-'] {
    width: auto;
  }

  & [class^='StyledDisplayTag-'],
  & [class*='StyledDisplayTag-'] {
    svg {
      display: none !important;
    }
  }
`;

export const StyledResetPinLink: any = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  text-align: left;
  width: auto;
  align-self: flex-start;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.button.primary.hover};
  }

  &:hover div {
    color: ${({ theme }) => theme.colors.button.primary.hover} !important;
  }
`;

export const StyledPinToastWrapper: any = styled.div`
  & > div > div {
    top: auto !important;
    bottom: 24px !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    min-width: ${({ theme }) => theme.size.grid020} !important;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    & > div > div {
      bottom: auto !important;
      left: auto !important;
      right: 16px !important;
      top: 80px !important;
      transform: none !important;
      min-width: unset !important;
    }
  }
`;

export const StyledCtaWrapper: any = styled.div`
  display: flex;
  width: 100%;

  & > * {
    width: 100%;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    justify-content: flex-end;

    & > * {
      width: auto;
    }
  }
`;
